// Categorías del catálogo. Por defecto vienen las 4 de Amway, pero el admin puede
// crear, renombrar y borrar (se guardan en app_settings.categories).
export const DEFAULT_CATEGORIES = ["Aseo Personal", "Hogar", "Nutrición", "Belleza"];

const BADGES = [
  "bg-secondary-500/20 text-secondary-200",
  "bg-accent-500/20 text-accent-200",
  "bg-primary-500/30 text-primary-100",
  "bg-accent-500/15 text-accent-100",
  "bg-primary-500/20 text-primary-100",
];

// Color de la etiqueta de categoría: las 4 fijas conservan su tono y cualquier
// categoría nueva recibe un tono estable según su nombre.
export const categoryBadge = (category: string): string => {
  const idx = DEFAULT_CATEGORIES.indexOf(category);
  if (idx >= 0) return BADGES[idx];
  let h = 0;
  for (let i = 0; i < category.length; i += 1) {
    h = (h * 31 + category.charCodeAt(i)) >>> 0;
  }
  return BADGES[h % BADGES.length];
};

// Lista efectiva de categorías: las configuradas o, si no hay, las 4 por defecto.
export const resolveCategories = (configured?: string[] | null): string[] => {
  const list = (configured ?? []).map((c) => c.trim()).filter(Boolean);
  return list.length > 0 ? list : DEFAULT_CATEGORIES;
};